<template>
  <div class="step-wrap" :class="{ iframeFontLarge: isInPassport }">
    <p class="mb-20">
      {{
        isCoolingOff
          ? languages.delSecondCheckMsg1
          : languages.delSecondCheckMsg2
      }}
    </p>
    <van-radio-group v-model="choose">
      <van-radio :name="1">{{ languages.delSecondCheckConfirmYes }}</van-radio>
    </van-radio-group>
    <div class="btn-wrap flex mb-60">
      <van-button class="btn" block type="info" @click="prevStep">
        {{ languages.delPrevStep }}
      </van-button>
      <van-button class="btn" block type="info" @click="handleNextStep">
        {{ languages.delNextStep }}
      </van-button>
    </div>
  </div>
</template>

<script>
import { stepKey } from '@configs/officialSupport/accountDelete';
import accountDelete from '@mixins/officialSupport/accountDelete';
export default {
  name: 'secondCheckDelete',
  mixins: [accountDelete],
  data() {
    return {
      choose: null,
      compKey: stepKey.secondCheckDelete
    };
  },
  methods: {
    handleNextStep() {
      if (!this.choose) {
        this.$toast(this.languages.smartOrderPleaseChoose);
        return;
      }
      this.updateSubmitForm({
        isActDelete: true
      });
      this.nextStep();
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialSupport/workTempForm.scss';
@import '@assets/scss/officialSupport/accountDelete.scss';
</style>
